<template>
  <div class="flex items-baseline rating" :class="[size ? size : '']">
    <div class="stars">
      <i class="icon icon-bor-star-full" v-for="(star, index) in fullRate" :key="`rate-full-${index}`"/>
      <i class="icon icon-bor-star-half" v-if="halfRate > 0"/>
      <i class="icon icon-bor-star-full empty" v-for="(star, index) in emptyRate" :key="`rate-empty-${index}`"/>
    </div>
    <span class="count">{{this.rate}}</span>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: ['rate', 'size'],
  data() {
    return {
      fullRate: 0,
      halfRate: 0,
      emptyRate: 0,
      startRange: 5
    }
  },
  mounted() {
    this.fullRate = Math.floor(this.rate ? this.rate : 0)
    this.halfRate = (this.rate ? this.rate : 0) - this.fullRate
    this.emptyRate = this.startRange - this.fullRate - Math.ceil(this.halfRate)
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>